import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaPt010 } from '~/endpoints/ApiTaPt010'
import { ApiTaPt020 } from '~/endpoints/ApiTaPt020'

// State types
// 努力賞ポイント取得
type HardPointNotice = {
  MemNum: string
  DrkPoint: number
} | null
const getEmptyHardPointNotice = (): HardPointNotice => ({
  MemNum: '',
  DrkPoint: 0,
})

// ぷちぽ取得
interface PassingSpotsObject {
  puchipoSpotId: string
  puchipoSpotImageUrl: string
  puchipoSpotTextDisp: string
  nextNeededPoint: number
}

type PuchipoNotice = {
  memNum: string
  grade: number
  puchipo: number
  reachSpot: string
  nextNeededPoint: number
  passingSpots: PassingSpotsObject[]
} | null
const getEmptyPuchipoNotice = (): PuchipoNotice => ({
  memNum: '',
  grade: 0,
  puchipo: 0,
  reachSpot: '',
  nextNeededPoint: 0,
  passingSpots: [
    {
      puchipoSpotId: '',
      puchipoSpotImageUrl: '',
      puchipoSpotTextDisp: '',
      nextNeededPoint: 0,
    },
  ],
})

// State action parameter
// ぷちぽ取得
interface ActionParamGrade {
  grade: number
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/Puchipo',
})
export default class Puchipo extends VuexModule {
  // State
  private hardPoint_ = getEmptyHardPointNotice()

  private puchipo_ = getEmptyPuchipoNotice()

  // Getter
  // 努力賞ポイント取得
  get hardPoint(): HardPointNotice {
    return this.hardPoint_
  }

  // ぷちぽ取得
  get puchipo(): PuchipoNotice {
    return this.puchipo_
  }

  // 努力賞ポイント取得
  @Mutation
  updateHardPoint(newState: HardPointNotice) {
    this.hardPoint_ = newState
  }

  // ぷちぽ取得
  @Mutation
  updatePuchipo(newState: PuchipoNotice) {
    this.puchipo_ = newState
  }

  // 努力賞ポイント取得
  // Actions
  @Action
  clear() {
    this.context.commit('updateHardPoint', getEmptyHardPointNotice())
    this.context.commit('updatePuchipo', getEmptyPuchipoNotice())
  }

  @Action
  async refreshHardPoint() {
    logger.trace('in: refreshHardPoint')
    const api = new ApiTaPt010.Api()

    const result = await api.get<HardPointNotice>(
      {},
      // success
      (data, _) => {
        return {
          MemNum: data.MemNum,
          DrkPoint: data.DrkPoint,
        }
      },
      // Error
      (_, __) => {
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateHardPoint', result)
  }

  // ぷちぽ取得
  @Action
  async refreshPuchipo(param: ActionParamGrade) {
    logger.trace('in: refreshPuchipo')
    const api = new ApiTaPt020.Api()

    const result = await api.get<PuchipoNotice>(
      {
        query: {
          grade: param.grade,
        },
      },
      // Success
      (data, _) => {
        return {
          memNum: data.memNum,
          grade: data.grade,
          puchipo: data.puchipo,
          reachSpot: data.reachSpot,
          nextNeededPoint: data.nextNeededPoint,
          passingSpots: data.passingSpots.map((spot): PassingSpotsObject => {
            return {
              puchipoSpotId: spot.puchipoSpotId,
              puchipoSpotImageUrl: spot.puchipoSpotImageUrl,
              puchipoSpotTextDisp: spot.puchipoSpotTextDisp,
              nextNeededPoint: spot.nextNeededPoint,
            }
          }),
        }
      },
      // Error
      (data, _) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updatePuchipo', result)
  }
}
